import { render, staticRenderFns } from "./ComplexTableView.vue?vue&type=template&id=4b64fda8"
import script from "./ComplexTableView.vue?vue&type=script&lang=js"
export * from "./ComplexTableView.vue?vue&type=script&lang=js"
import style0 from "./ComplexTableView.vue?vue&type=style&index=0&id=4b64fda8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports